import React from 'react';
import { UI } from 'src/apps/invest/signup/views/components/UI';
import { useSignUpModel } from '../../models/SignUpModel';
import { EmailForm } from '../components/EmailForm';
import { Transition } from '../components/Transition';

export const SignUpEmailPage: React.FC = () => {
  const { email } = useSignUpModel();

  return (
    <UI nextPage={email ? () => useSignUpModel.setState({ page: 'PASSWORD' }) : undefined}>
      <Transition>
        <EmailForm />
      </Transition>
    </UI>
  );
};
